module.exports = __webpack_public_path__ + "img/cardboard-boxes.14b1270c.png";